


























import Vue from 'vue';
import Helpers from '../mixins/helpers';
import { mapState } from 'vuex';
export default Vue.extend({
	name: 'CarSelector',
	data: function(){
		return {
			selectedVehicle: -1
		};
	},
	computed: {
		...mapState({
			lightTheme(): boolean {
				return this.$store.state.app.theme == 'light';
			},
			vehicle(): any {
				return this.$store.state.vehicle;
			},
			vehicleArray(): Array<any> {
				return this.$store.state.vehicleArray;
			}
		}), 
		colours(): Array<any> {
			const c = this.vehicleArray.map(v => {
				const code = v.Materialcode.substring(v.Materialcode.length - 3);
				return {
					text: v.Paint,
					colour: Helpers.getColour(code) || '', 
					darktick: code == '040'
				}; 
			});
			return c;
		}
	}, 
	methods: {
		handleCarChange(i: number): void {
			this.selectedVehicle = i;
			this.$store.commit('setVehicle', this.vehicleArray[i]);
		}
	}, 
	mounted(){
		const i = this.vehicleArray.findIndex(v => v.Materialcode == this.vehicle.Materialcode);
		if (i != -1){
			this.selectedVehicle = i;
		}
	}
});
